import _ from "lodash";

export default _.mapKeys([
	"UPDATE_LAYOUT_PROPS",
	"LOGIN_USER",
	"SET_USER_ROLE",
	"LOGOUT_USER",
	"UPDATE_COMPONENT_INSTANCE_IN_PAGE",
	"SET_SECONDARY_HEADER",
	"UPDATE_PAGE_DATA",
	"SET_LAYOUTS",
	"SET_BACKEND_ERROR_MESSAGE",
	"GENERATE_NEW_SESSION_ID",
	"SET_VALIDATION_ERROR",
	"FETCH_USERS_REQUEST",
	"FETCH_USERS_FAILURE",
	"SET_USERS",
	"FETCH_SECTION_REQUEST",
	"FETCH_SECTION_FINISHED",
	"SET_CURRENT_SECTION_INDEX",
	"SET_SECTION"
]);
